<template>
	<section>
		<aside :style="asideClass" :class="menushow ? 'width2' : 'width1'">
			<el-menu
				class="el-menu-vertical-demo"
				text-color="#fff"
				active-text-color="#fff"
				:default-active="defaultActivePath"
				router
			>
				<menu-item
					v-for="(item, index) in menuList"
					:item="item"
					:key="index"
				></menu-item>
			</el-menu>
		</aside>
		<div
			:style="asideClass"
			class="main-content"
			:class="menushow ? 'width3' : 'width4'"
		>
			<transition name="fade-transform" mode="out-in">
				<keep-alive :include="catch_components">
					<router-view />
				</keep-alive>
			</transition>
		</div>
	</section>
</template>
<script>
import MenuItem from "@/components/MenuItem";
import { mapGetters } from "vuex";
export default {
	components: {
		MenuItem
	},
	data() {
		return {
			perms: JSON.parse(window.sessionStorage.getItem("perms")),
			asideClass: "",
			width1: "",
			width2: "",
			defaultActivePath: "",
			menuList: []
		};
	},
	computed: {
		...mapGetters(["menushow", "catch_components"]),
		key() {
			return this.$route.path;
		}
	},
	created() {
		this.init();
		// 处理路由重复点击报错问题
		this.handleRepeatRoute();
	},
	watch: {
		$route(from, to) {
			this.handleRepeatRoute();
		}
	},
	methods: {
		handleRepeatRoute() {
			this.defaultActivePath = this.$route.path;
			if (this.$route.name != "home") {
				this.$store.commit("app/addKeepAliveCache", this.$route.name);
			}
		},

		init() {
			let menuArray = [];
			if (this.perms.includes("m_business_data")) {
				let routeObj = {
					title: "业务数据",
					icon: "yakult-icon-1",
					path: "/businessData",
					children: []
				};
				if (this.perms.includes("m_order")) {
					routeObj.children.push({
						title: "客商订单",
						path: "/businessData/merchantOrder"
					});
				}
				if (this.perms.includes("m_receipt")) {
					routeObj.children.push({
						title: "收款单",
						path: "/businessData/collectionOrder"
					});
				}
				if (this.perms.includes("m_load_vehicle")) {
					routeObj.children.push({
						title: "装车单",
						path: "/businessData/shipOrder"
					});
				}
				if (this.perms.includes("m_store_check")) {
					routeObj.children.push({
						title: "生动化检查",
						path: "/businessData/vividCheck"
					});
				}
				if (this.perms.includes("m_agent_stock")) {
					routeObj.children.push({
						title: "客商库存",
						path: "/businessData/agentStock"
					});
				}
				if (this.perms.includes("m_other_out")) {
					routeObj.children.push({
						title: "其它出库单",
						path: "/businessData/otherOrder"
					});
				}

				if (this.perms.includes("m_signin")) {
					routeObj.children.push({
						title: "签到拜访表",
						path: "/businessData/signForm"
					});
				}
				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_report")) {
				let routeObj = {
					title: "业务报表",
					icon: "yakult-icon-2",
					path: "/businessTable",
					children: []
				};
				if (this.perms.includes("m_round_report")) {
					routeObj.children.push({
						title: "巡回日报",
						path: "/businessTable/tourDaily"
					});
				}
				if (this.perms.includes("m_agent_book")) {
					routeObj.children.push({
						title: "客商台账",
						path: "/businessTable/merchantAccount"
					});
				}
				if (this.perms.includes("m_agent_sale_book")) {
					routeObj.children.push({
						title: "销售台账",
						path: "/businessTable/saleAccount"
					});
				}
				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_route")) {
				let routeObj = {
					title: "路线管理",
					icon: "yakult-icon-3",
					path: "/routeManagement",
					children: []
				};
				if (this.perms.includes("m_route_set")) {
					routeObj.children.push({
						title: "路线",
						path: "/routeManagement/route"
					});
				}
				if (this.perms.includes("m_route_map")) {
					routeObj.children.push({
						title: "路线地图",
						path: "/routeManagement/map"
					});
				}
				if (this.perms.includes("m_round_set")) {
					routeObj.children.push({
						title: "巡回计划",
						path: "/routeManagement/tour"
					});
				}
				if (this.perms.includes("m_route_goal")) {
					routeObj.children.push({
						title: "路线目标管理",
						path: "/routeManagement/goal"
					});
				}
				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_agent_mgr")) {
				let routeObj = {
					title: "客商管理",
					icon: "yakult-icon-4",
					path: "/merchantManagement",
					children: []
				};
				if (this.perms.includes("m_agern_info")) {
					routeObj.children.push({
						title: "客商信息",
						path: "/merchantManagement/info"
					});
				}
				if (this.perms.includes("m_agent_limit")) {
					routeObj.children.push({
						title: "预付款额度",
						path: "/merchantManagement/subsist"
					});
				}
				if (this.perms.includes("m_warehouse_set")) {
					routeObj.children.push({
						title: "出货仓设置",
						path: "/merchantManagement/warehouse"
					});
				}
				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_bdata")) {
				let routeObj = {
					title: "基础数据",
					icon: "yakult-icon-5",
					path: "/baseDataManagement",
					children: []
				};
				if (this.perms.includes("m_sku_set")) {
					routeObj.children.push({
						title: "SKU管理",
						path: "/baseDataManagement/skuManage"
					});
				}
				if (this.perms.includes("m_code_set")) {
					routeObj.children.push({
						title: "数据字典",
						path: "/baseDataManagement/dataDictionary"
					});
				}
				if (this.perms.includes("m_price_set")) {
					routeObj.children.push({
						title: "价格管理",
						path: "/baseDataManagement/priceManage"
					});
				}
				if (this.perms.includes("m_auto_sale_price_set")) {
					routeObj.children.push({
						title: "自贩价格管理",
						path: "/baseDataManagement/automaticPrice"
					});
				}
				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_vehicle")) {
				let routeObj = {
					title: "车辆管理",
					icon: "yakult-icon-6",
					path: "/vehicleManagement",
					children: []
				};
				if (this.perms.includes("m_vehicle_info")) {
					routeObj.children.push({
						title: "车辆信息",
						path: "/vehicleManagement/vehicleInfo"
					});
				}
				if (this.perms.includes("m_vehicle_mileage")) {
					routeObj.children.push({
						title: "车辆里程",
						path: "/vehicleManagement/mileage"
					});
				}
				if (this.perms.includes("m_vehicle_refuel")) {
					routeObj.children.push({
						title: "车辆加油",
						path: "/vehicleManagement/refuel"
					});
				}

				menuArray.push(routeObj);
			}
			if (this.perms.includes("m_sys_set")) {
				let routeObj = {
					title: "系统设置",
					icon: "yakult-icon-7",
					path: "/systemManagement",
					children: []
				};
				if (this.perms.includes("m_sys_user")) {
					routeObj.children.push({
						title: "用户管理",
						path: "/systemManagement/userManagement"
					});
				}
				if (this.perms.includes("m_sys_role")) {
					routeObj.children.push({
						title: "角色管理",
						path: "/systemManagement/roleManagement"
					});
				}
				if (this.perms.includes("m_sys_group")) {
					routeObj.children.push({
						title: "组织设定",
						path: "/systemManagement/groupSet"
					});
				}
				menuArray.push(routeObj);
			}
			this.menuList = menuArray;
		}
	}
};
</script>
<style lang="scss" scoped>
section {
	width: 100%;
	height: calc(100% - 48px) !important;
	display: flex;
	clear: both;
}
aside {
	display: inline-block;
	vertical-align: top;
	overflow-x: hidden;
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 5px;
		height: 10px;
	}
	&::-webkit-scrollbar-track {
		border-radius: 2px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 5px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: #bbb;
	}
}
.main-content {
	display: inline-block;
	height: 100%;
	vertical-align: top;
	background-color: #f3f2f7;
	box-sizing: border-box;
}
.width1 {
	flex-shrink: 0;
	width: 0;
}
.width2 {
	flex-shrink: 0;
	width: 200px;
}
.width3 {
	// flex: 1;
	width: calc(100% - 200px);
	box-sizing: border-box;
	// overflow: auto;
}
.width4 {
	flex: 1;
	width: 100%;
	// overflow: auto;
}
.el-menu {
	height: 100%;
	border-right: none;
	background-color: #20335d;
	.el-menu-item {
		background-color: #20335d;
		&:hover {
			background-color: rgba(14, 21, 37, 1);
		}
	}
	.el-menu-item.is-active {
		background-color: rgba(14, 21, 37, 1);
	}
	/deep/ .el-submenu__title {
		background-color: #20335d;
	}
	/deep/ .el-submenu__title:hover {
		background-color: rgba(14, 21, 37, 1);
	}
	/deep/ .el-menu-item-group__title {
		padding: 0;
	}
}
.el-submenu {
	width: 200px;
	.el-menu-item {
		min-width: 199px;
	}
}
</style>
